module.exports = __webpack_public_path__ + "static/media/kmz.b6cbd292.svg";